import { takeEvery, put, call, fork } from 'redux-saga/effects';

import { Client } from '../../utils/client';
import { SPORTS_DETAIL_LOAD, sportsDetailLoadSuccess, PACKAGE_CHANNEL_LOAD, packageChannelLoadSuccess } from './actions';
import { setError } from '../../redux-root/actions';

const getAllPackageData = async (list) => {
  const newList = list.map(id => {
    return Client.getData(`/packages/?offset=0&limit=200&iscurrent=true&channelid=${id}`).then(res => {
      delete res.status;
      res.id = id;
      res.data = res.data.splice(0, 3);

      return res;
    });
  });

  return Promise.all(newList);
}

export function* sportsDetailLoad(action) {
  const { id, platformType } = action;

  try {
    const sportsDetailData = yield call(Client.getData, `/pages/${id}?platformType=${encodeURIComponent(platformType)}`);

    // const sportsRes = sportsDetailData.data;

    // if (sportsRes && sportsRes.collections && sportsRes.collections.length > 0) {
    //   const filterLaneList = sportsRes.collections.map(l => {
    //     let newLane = l;

    //     if (newLane.layoutStyle === 'LS21') {
    //       newLane.items = newLane.items.filter(i => {
    //         const nowDate = new Date();
    //         const itemEndDate = new Date(`${i.endDate}Z`);

    //         if (nowDate <= itemEndDate) {
    //           return i;
    //         }
    //       });
    //     }

    //     return newLane;
    //   });
    // }

    yield put(sportsDetailLoadSuccess(sportsDetailData.data));
  } catch (error) {
    console.log(error);

    yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  }
}

export function* packageChannelLoad(action) {
  const { payload } = action;

  try {
    const packageData = yield call(getAllPackageData, payload);

    yield put(packageChannelLoadSuccess(packageData));
  } catch (error) {
    console.log(error);
  }
}

function* watchSportsDetailLoad() {
  yield takeEvery(SPORTS_DETAIL_LOAD, sportsDetailLoad);
}

function* watchPackageChannelLoad() {
  yield takeEvery(PACKAGE_CHANNEL_LOAD, packageChannelLoad);
}

export function* sportsDetailSaga() {
  yield fork(watchSportsDetailLoad);
  yield fork(watchPackageChannelLoad);
}
